
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faMagnifyingGlass, faArrowRight, faSpinner, faFileInvoice, faUsersLine, faBan, faBook, faFloppyDisk, faCashRegister } from '@fortawesome/free-solid-svg-icons';
//import { Modal } from 'react-bootstrap';


import EditListingButton from './EditListingButton.js';
import AddListingModal from './AddListingModal.js';

//import { useNavigate } from 'react-router-dom';

import useAuthUser from 'react-auth-kit/hooks/useAuthUser';


export default function ListingCard(props) {
    const { listItem, imgPreviewUrl } = props;

    const [contextListItem, setContextListItem] = useState(listItem ?? null);

    const [modalDisplay, setModalDisplay] = useState(false);

    const authUser = useAuthUser();

    const [showEdit, setShowEdit] = useState(false);

    useEffect(() => {

    }, [imgPreviewUrl]);

    //function handleEdit(e) 
    //{
    //    //setModalDisplay(e.target.value);

    //     console.log("Edit Mode");
    //     <AddListingModal isOpen={true}/>;
    //     console.log("After Modal in Edit Mode");
    // }

    //console.log(listItem);

    //const navigate = useNavigate();

    const handleRegisterClick = () => {
        window.location.href = contextListItem.listingRegisterURL;
    };

    const handleDetailClick = () => {

        window.location.href = contextListItem.listingDetailURL;
    };

    const editedListing = (edtListing) => {
        setContextListItem(edtListing);
    };

    return (

        <div className="col mb-2" key={"listing-" + contextListItem ? contextListItem.listingId : null} >
            <div className="card h-100 border-dark" style={{ boxShadow: "0px 0px 6px 2px #4A4A4A" }} >
                <div className="card-header bg-dark gy-0 border-dark py-1"  >
                    <div className="row" >
                        <div className="col-5 text-start gx-2 ps-2 gy-0 text-white" style={{ fontSize: ".90em" }} >

                            {contextListItem.listingDate ? moment(contextListItem.listingDate).format('MM-DD-yyyy') : null}

                        </div>
                        <div className="col-7 pe-1 text-end gy-0 text-white" style={{ fontSize: ".90em" }} >
                            {contextListItem.listingCity}{contextListItem.listingStateProv ? ', ' + contextListItem.listingStateProv : '\u00A0'}
                        </div>
                    </div>
                </div>

                <div className="card-header bg-secondary text-primary border-dark border-top">
                    <div className="row">
                        <div className="col-7">
                            <p className="text-white truncate pb-0 mb-0 ps-0">{contextListItem.listingName}</p>
                        </div>
                        <div className="col-5 text-end pe-1">
                            <span className="badge text-black bg-light">{contextListItem.listingClass && "Class " + contextListItem.listingClass}
                            </span>
                        </div>
                    </div>


                </div>

                <div className="card-body border-dark px-2 py-2" style={{ backgroundColor: "#cec7c759" }} >
                    {imgPreviewUrl ?
                        <img className="card-img-top img-fluid" style={{ zIndex: -1 }} src={"https://ik.imagekit.io/sidekick/listings/" + (imgPreviewUrl)} />
                        :
                        <img className="card-img-top img-fluid" style={{ zIndex: -1 }} src={"https://ik.imagekit.io/sidekick/listings/" + (contextListItem.listingImageURL ? contextListItem.listingImageURL : "listing_placeholder.jpeg")} ></img>
                    }

                    {contextListItem.listingCircuit && (contextListItem.listingCircuit != 'OTHER' && contextListItem.listingCircuit != 'OPEN') &&

                        <div style={{ position: 'absolute', left: 16, top: 100, width: "40px", display: "flex" }}>
                            <img style={{ position: 'relative', top: 0, objectFit: "contain", zIndex: 1, height: "100%", width: "100%" }} src={"https://ik.imagekit.io/sidekick/logos/" + contextListItem.listingCircuit.toLowerCase() + "_circuit_logo.png"} ></img>
                        </div>
                    }
                    {contextListItem.listingTournamentId &&

                        <div style={{ position: 'absolute', right: 16, top: 100, width: "40px", display: "flex" }}>
                            <img style={{ position: 'relative', top: 0, objectFit: "contain", zIndex: 1, height: "100%", width: "100%" }} src={"https://ik.imagekit.io/sidekick/logos/sidekick_circuit_logo.png"} ></img>
                        </div>
                    }
                </div>
                <div className="card-footer border-dark bg-black" style={{ height: "50px" }}>
                    <div className="row text-center">
                        <div className="col-4 text-center">
                            {!contextListItem.isPreview &&
                                <button
                                    className="btn btn-primary px-1"
                                    style={{ cursor: "pointer", position: "absolute", left: "20px", width: "24%", height: "35px", fontSize: ".8em" }}
                                    onClick={handleRegisterClick}
                                    disabled={!contextListItem.listingRegisterURL}
                                >Register
                                </button>
                            }
                        </div>
                        {/* != null && authUser.profile.profileId === contextListItem.listingProfileId authUser.profile.profileId*/}
                        <div className="col-4 text-white">
                            <EditListingButton listItem={contextListItem} editedListing={editedListing} />
                        </div>
                        <div className="col-4 text-center">
                            {!contextListItem.isPreview && contextListItem.listingDetailURL &&
                                <button
                                    className="btn btn-primary px-1"
                                    style={{ cursor: "pointer", position: "absolute", right: "20px", width: "24%", height: "35px", fontSize: ".8em" }}
                                    onClick={handleDetailClick}>Details
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

